
function LabelledInput ( { id, label, value, error, onChange, type, editable, onBlur } )
{
    return  <div className="py-2">
                <label htmlFor={id}>{label} {error}</label>
                <input id={id} value={value} type={type} onChange={ ( e ) => onChange ( e.target.value ) } disabled={editable === false} onBlur={ onBlur ? () => onBlur () : null } />
            </div>
}

export default LabelledInput;